import { types as coreTypes } from '@sitebuilder/core';

export interface IUsersClient {
    executeQuery<T extends coreTypes.Users>(
        authorizationToken: string | null | undefined
    ): Promise<T>;
}

export class UsersApiClient implements IUsersClient {
    baseUrl: string;
    constructor(baseUrl: string = '') {
        this.baseUrl = baseUrl;
    }

    async executeQuery<T extends coreTypes.Users>(
        authorizationToken: string | null | undefined
    ): Promise<T> {
        const resp = await fetch(`/api/admin/usermanagement/`, {
            method: 'GET',
            headers: {
                authorization: `bearer ${authorizationToken}`,
                'Content-Type': 'application/json',
            },
        });

        if (!resp.ok) {
            const body = await resp.text();
            throw new Error(`Invalid response from server: Status: ${resp.status}\n${body}`);
        }

        const data = (await resp.json()) as T;

        return data;
    }
}
